import { NgModule } from '@angular/core';
import { ContractManagementExcelComponent } from './contract-management-excel.component';
import { OpenprojectCommonModule } from '../common/openproject-common.module';
import {  CunstomFormsLoadingComponent } from './components/cunstom-forms-loading/cunstom-forms-loading.component'

import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';

export const CONTRACT_MANAGEMENT_EXCEL_ROUTES: Ng2StateDeclaration[] = [
  {
    name: 'contract_management_excel',
    url: '/contract_management_excel',
    parent: 'root',
    component: ContractManagementExcelComponent
  }
];

@NgModule({
  imports: [
    OpenprojectCommonModule,
    HttpClientModule,
    FormsModule,
    UIRouterModule.forChild({
      states: CONTRACT_MANAGEMENT_EXCEL_ROUTES
    })
  ],
  declarations: [
    ContractManagementExcelComponent,
    CunstomFormsLoadingComponent
  ]
})
export class ContractManagementExcelModule { }